module.exports = __webpack_public_path__ + "static/img/icono-clase.ca9729c1.svg";